import React from 'react';
import { toast } from 'react-toastify';
import { validateImageFile } from '../../utils/fileValidation';

/* imageSrc arriva gia' filtrato dal chiamante: e' una data URI oppure null.
 * Quando e' null non si mostra alcun riquadro fittizio — un placeholder
 * grafico farebbe pensare a un'immagine che non si carica, mentre qui
 * semplicemente non ne e' mai stata caricata una. */
const ProfileImageTab = ({ imageSrc, onUpload }) => {
  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    const { valid, error } = validateImageFile(file);
    if (!valid) {
      toast.error(error);
      e.target.value = '';
      return;
    }
    onUpload(file);
  };

  return (
    <div className="scheda-immagine">
      <h3 className="scheda-immagine__titolo">Immagine profilo</h3>

      {imageSrc ? (
        <figure className="scheda-immagine__anteprima">
          <img src={imageSrc} alt="Immagine profilo dell'azienda" />
          <figcaption>Immagine attuale</figcaption>
        </figure>
      ) : (
        <p className="scheda-immagine__assente">
          Nessuna immagine profilo caricata per questa azienda.
        </p>
      )}

      <label className="scheda-immagine__azione" htmlFor="profile-image-upload">
        {imageSrc ? 'Sostituisci immagine' : 'Carica immagine'}
      </label>
      <input
        id="profile-image-upload"
        type="file"
        accept="image/*"
        onChange={handleFileSelect}
      />
      <p className="scheda-immagine__nota">
        Formati accettati: JPG, PNG. L'immagine sostituisce quella esistente.
      </p>
    </div>
  );
};

export default ProfileImageTab;
